module.exports = __webpack_public_path__ + "static/img/pmriGrid.8b7e9268.png";